import src from "IMAGE";
export default { src, width: 1195, height: 905, blurWidth: 0, blurHeight: 0};
